<ng-container *ngIf="shouldShowActivationUI">
    <div class="mb-4 bg-white shadow-md dark:bg-contrast-black">
        <h1 class="p-4 text-left text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow">
            {{ this.products[0]?.name | translateObjectField: null : currentLanguage }}
        </h1>
    </div>
    <div class="w-auto overflow-y-auto bg-white p-4" *ngIf="activationMenuElements.length > 1">
        <p class="mb-2 text-sm font-semibold leading-5 tracking-wider text-grey-dark dark:text-contrast-yellow">
            {{ 'ACTIVATION_DATE' | translate | uppercase }}
        </p>
        <div class="border-t border-solid border-black border-opacity-10 pt-4">
            <ion-segment
                class="orb-app-light-dark:h-10 var-app-light-dark:h-11"
                [(ngModel)]="selectedActivationType"
                (ionChange)="typeSelected(selectedActivationType)"
                color="dark"
                mode="ios">
                <ion-segment-button
                    class="orb-app-light-dark:m-0"
                    *ngFor="let activationMethod of activationMenuElements"
                    [value]="activationMethod">
                    <ion-label
                        class="orb-app-light-dark:font-semibold orb-app-light:text-grey-zambezy orb-app-light-dark:text-base var-app-light-dark:font-semibold var-app-light:text-grey-zambezy"
                        [ngClass]="{ 'dark:text-contrast-black': selectedActivationType === activationMethod }"
                        >{{ 'ACTIVATE_TICKET_' + activationMethod | translate }}</ion-label
                    >
                </ion-segment-button>
            </ion-segment>
        </div>

        <div class="pt-6" *ngIf="selectedActivationType === ActivationType.BEFORE_PURCHASE">
            <div class="flex-justify-between flex-align-center select-date flex">
                <span>{{ 'ACTIVATE_DATE' | translate }}</span>
                <div class="flex-justify-between flex">
                    <ion-item class="h-[3.50rem] dark:bg-contrast-yellow" id="open-activation-modal">
                        <ion-input
                            class="text-center dark:bg-contrast-yellow dark:text-contrast-black"
                            value="{{ activationDateTime.datetime | date: env.ACTIVATION_DATE_DISPLAY_FORMAT }}"
                            type="text"
                            readonly></ion-input>
                        <ion-button
                            class="var-app-light:text-white"
                            [attr.aria-label]="'SET' | translate"
                            clear
                            item-right>
                            <ion-icon
                                class="h-[1.25rem] pr-2"
                                aria-hidden="true"
                                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/activation/time.svg">
                            </ion-icon>
                            {{ 'SET' | translate }}
                        </ion-button>
                    </ion-item>
                </div>
            </div>
            <div class="flex-justify-between ticket-end-day flex pt-4" *ngIf="this.products[0]">
                <span class="text">{{ 'TICKET_END_DAY' | translate }}</span>
                <span class="end-date">{{
                    ticketEnd(this.products[0]?.name | translateObjectField: null : currentLanguage)
                        | date: env.ACTIVATION_DATE_DISPLAY_FORMAT
                }}</span>
            </div>
            <div class="flex-column text-bottom flex pt-5">
                <p class="text-grey-dark dark:text-contrast-yellow">
                    {{ 'TICKET_LATEST_DAY_ACTIVATION' | translate }}
                </p>
                <p class="text-grey-dark dark:text-contrast-yellow">
                    {{ 'TICKET_VALID_INFO' | translate }}
                </p>
            </div>
        </div>

        <div class="pt-6" *ngIf="selectedActivationType === ActivationType.AFTER_PURCHASE">
            <p class="text-grey-dark dark:text-contrast-yellow">
                {{ 'ACTIVATION_IMMEDIATE_PURCHASE_INFO' | translate }}
            </p>
        </div>
        <div class="pt-6" *ngIf="selectedActivationType === ActivationType.MANUAL">
            <p class="text-grey-dark dark:text-contrast-yellow">
                {{ 'ACTIVATION_MANUAL_INFO' | translate }}
            </p>
        </div>
    </div>

    <div class="next-button__wrap absolute flex w-full bg-white" *ngIf="isShowInnerNextButton">
        <ion-button
            class="next-button mx-[1.125rem] my-4 w-full tracking-normal"
            [attr.aria-label]="'CONTINUE_TO_CHECKOUT' | translate"
            (click)="handleNextClicked()"
            size="large">
            <ion-label
                class="vl-app-light:text-black var-app-light:text-black whitespace-normal text-base font-bold normal-case dark:text-contrast-black">
                {{ 'CONTINUE_TO_CHECKOUT' | translate }} ({{ getTotalAmount() | moneyFormat }}
                {{ currency | translate }})
            </ion-label>
            <ion-icon
                class="vl-app-light:text-black var-app-light:text-black"
                name="arrow-forward-outline"
                slot="end"></ion-icon>
        </ion-button>
    </div>
</ng-container>

<ridango-ui-datetime-select
    *ngIf="selectedActivationType === ActivationType.BEFORE_PURCHASE"
    [(ngModel)]="activationDateTime"
    [triggerId]="'open-activation-modal'"
    [minDate]="minDate"
    [maxDate]="maxDate"
    (ngModelChange)="setActivationDateTime($event)"
    dateOnly="true">
</ridango-ui-datetime-select>
